import IntegrationError from "../IntegrationError";

export const resolveContainer = (domElement) => {
    if (!domElement) {
        throw new IntegrationError("DOM element is required.")
    }

    if ("string" === typeof domElement) {
        let bySelector = document.querySelectorAll(domElement);
        if (bySelector.length > 1) {
            console.warn(`Found ${bySelector.length} containers for selector '${domElement}'. Component will be mounted to first one.`);
        } else if (!bySelector.length) {
            throw new IntegrationError(`Selector '${domElement}' returns no DOM elements.`);
        }

        return bySelector[0];
    } else {
        if (!domElement.appendChild) {
            throw new IntegrationError("Invalid DOM element.");
        }

        return domElement;
    }
}